import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Platform, MenuController, App} from 'ionic-angular';
import { ServiceProvider } from '../../providers/service/service';
import { Device } from '@ionic-native/device';
import { Storage } from '@ionic/storage';
import { AlertController, Nav, ToastController, LoadingController } from 'ionic-angular';
import { Events } from 'ionic-angular';
import {DashboardHomePage} from "../dashboard-home/dashboard-home";
import {AndroidPermissions} from "@ionic-native/android-permissions";

//@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  username:any;
  password:any;
  menu:any;
  UserType:any;


  DeviceCordova: any;
  DeviceModel: any;
  DevicePlatform: any;
  DeviceUUID: any;
  DeviceVersion: any;
  DeviceManufacturer: any;
  DeviceSerial: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, public service: ServiceProvider, public platform:Platform, menuCtrl:MenuController, private device: Device, public loadingCtrl: LoadingController, public toastCtrl: ToastController,
              public storage: Storage,
              public _app: App,
              public event: Events,
              private androidPermissions: AndroidPermissions) {

    this.platform.ready().then(() => {
      console.log('Device UUID is: ' + this.device.uuid);
      this.DeviceCordova = this.device.cordova;
      this.DeviceModel = this.device.model;
      this.DevicePlatform = this.device.platform;
      this.DeviceUUID = this.device.uuid;
      this.DeviceVersion = this.device.version;
      this.DeviceManufacturer = this.device.manufacturer;
      //$scope.DeviceIsVirtual = device.device.isVirtual;
      this.DeviceSerial = this.device.serial;

      this.checkPermission();

      this.menu=menuCtrl;
      menuCtrl.enable(false);
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }

  login() {

    let loading = this.loadingCtrl.create({
      content: 'Logging In'
    });
    loading.present();

    var datas = {
      UserName: this.username,
      Password: this.password
    }

        console.log('token',this.service.token);
      if (this.service.token == "" /*|| this.service.token == null || this.service.token == undefined*/) {
        let toast = this.toastCtrl.create({
          message: 'Please check your internet connection and try again.',
          duration: 5000,
          position: 'middle'
        });
        toast.present();

        loading.dismiss();
      }
      else {
        setTimeout(() => {
          loading.dismiss();
        }, 10000);
        this.service.httppostcall('web_service/app_login', datas).subscribe(data => {
          console.log(data);
          loading.dismiss();
          if (data['status'] == 'success') {

            var token = this.service.token;

            //---------------------
            var Id = data['LoginData']['Id'];

            var update_datas = {
              Id: Id,
              FUserId: data['UserData']['Id'],
              FUserTypeId: data['LoginData']['FUserTypeId'],
              token: token,
              DeviceCordova: this.DeviceCordova,
              DeviceModel: this.DeviceModel,
              DevicePlatform: this.DevicePlatform,
              DeviceUUID: this.DeviceUUID,
              DeviceVersion: this.DeviceVersion,
              DeviceManufacturer: this.DeviceManufacturer,
              DeviceSerial: this.DeviceSerial
            }

            console.log("update_datas",update_datas);
            this.service.httppostcall('web_service/update_app_login', update_datas).subscribe(update_data => {
              console.log('Update_Data' + JSON.stringify(update_data));
              if (update_data['response'] == 'success') {


                this.storage.set("AllotedMobileNumber", data['LoginData']['AllotedMobileNumber']);
                this.storage.set("UserData", data['UserData']);
                this.storage.set("LoginData", data['LoginData']);
                console.log("LoginData",data['LoginData']['FUserId']);
                this.storage.set("FUserId", data['LoginData']['FUserId']);
                this.storage.set("UserName", data['UserData']['Name']);
                this.service.UserName = data['UserData']['Name'];
                this.app_tabs_rights_by_user_id(data['LoginData']['FUserId']);

                this.menu.enable(true);

                this._app.getRootNav().setRoot(DashboardHomePage);

                //this.navCtrl.push(OtpPage);

              }
            });

            //-----------------------------


          } else {

            let toast = this.toastCtrl.create({
              message: data['message'],
              duration: 5000,
              position: 'bottom'
            });
            toast.present();

          }

        });
      }


  }

  get_nav(FUserTypeId) {
    this.event.publish('get_nav', {FUserTypeId: FUserTypeId});
  }

  app_tabs_rights_by_user_id(FUserId) {
    this.event.publish('app_tabs_rights_by_user_id', {FUserId: FUserId});
  }

  checkPermission()
  {
    console.log("Check Permission");
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then(result => {
          //this.hasPermission = result.hasPermission;
          console.log('Has permission?', result['hasPermission']);
          if (result['hasPermission']) {
            console.log("Has Permission");
          } else {
            console.log("Deny Permission");
            this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then((result_data) => {
              console.log(result_data);
              if (result_data['hasPermission']) {
                console.log('storage allow ', result_data['hasPermission']);
              } else {
                console.log('storage deny ', result_data['hasPermission']);
              }
            }).catch((err) => {
              console.log("catch loop",JSON.stringify(err));
            });
          }
        },
        err => {
          this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then((result_data) => {
            console.log(result_data);
            console.log('error Has permission?', result_data['hasPermission']);
            if (result_data['hasPermission']) {
              console.log('err storage allow ', result_data['hasPermission']);
            } else {
              console.log('err storage deny ', result_data['hasPermission']);
            }
          }).catch((err) => {
            console.log(JSON.stringify(err));
          });
        });

  }



}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts